import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import { getDateID } from '@/data/helper.js';
Vue.use(Vuex)

// use this baseUrl for staging
// const baseURL = 'https://simrs.idgw.site/api/';
// const baseStorageURL = 'https://simrs.idgw.site/storage/';
// const siakunURL = 'https://pbec-siakun.web.app';
// const siakunBaseURL = 'https://siakun.idgw.site/api/';
// const hrisURL = 'https://hris.idgw.site';
// const hrisBaseURL = 'https://hris.idgw.site/api/';

// use this baseUrl for testing
const baseURL = 'https://simrs-test.idgw.site/api/';
const baseStorageURL = 'https://simrs-test.idgw.site/storage/';
const siakunURL = 'https://pbec-siakun-test.firebaseapp.com/';
const siakunBaseURL = 'https://wp-finance.idgw.site/api/';
const hrisURL = 'https://wp-corporate.idgw.site';
const hrisBaseURL = 'https://wp-corporate.idgw.site/api/';

// Catatan: Untuk membedakan id petugas dan id dokter supaya tidak bentrok, dan karena idnya hanya bisa integer, maka ada kode di depan idnya:
// Dokter: DOK -> 4-15-11 -> 41511
// Petugas: PTG -> 16-20-7 -> 16207
const prefixDok = '41511';
const prefixPtg = '16207';
export const patientTypes = {
  1: 'Umum', 2: 'BPJS', 3: 'Asuransi'
}

// const hrisBaseURL = 'http://127.0.0.1:3333/api/';
export const roles = [
  { label: 'Admin', value: 'admin' },
  { label: 'Admin Pendaftaran', value: 'admission' },
  { label: 'Admin Ralan', value: 'ralan' },
  { label: 'Admin Ranap', value: 'ranap' },
  { label: 'Admin UGD', value: 'ugd' },
  { label: 'Admin Operasi', value: 'operasi' },
  { label: 'Kasir', value: 'kasir' },
  { label: 'Petugas Lab', value: 'lab' },
  { label: 'Petugas Apotik', value: 'apotik' },
  { label: 'Petugas Optik', value: 'optik' },
  { label: 'Pasien', value: 'pasien' },
  { label: 'Antrian', value: 'antrian' },
  { label: 'Dokter', value: 'dokter' }
];
const menus = [
  { label: 'Pasien Baru', icon: 'person_add', class: 'primary', link: 'pasien/form', authorized: ['admin', 'admission', 'dokter', 'pasien'] },
  { label: 'Pasien Lama', icon: 'person', class: 'secondary', link: 'ralan/daftar', authorized: ['admin', 'admission', 'dokter', 'pasien'] },
  { label: 'Antrian Pasien', icon: 'queue_play_next', class: 'secondary', link: 'antrian/pasien', authorized: ['antrian'] },
  { label: 'Rekam Medis', icon: 'perm_contact_calendar', class: 'secondary', link: 'pasien', authorized: ['admin', 'admission', 'ralan', 'ranap', 'ugd', 'operasi', 'lab', 'apotik', 'optik', 'dokter'] },
  { label: 'Ralan Baru', icon: 'add_circle', class: 'primary', link: 'ralan/daftar', authorized: ['admin', 'admission', 'ralan'] },
  { label: 'List Ralan', icon: 'local_hospital', class: 'secondary', link: 'ralan', authorized: ['admin', 'admission', 'ralan', 'ranap', 'operasi', 'lab', 'apotik', 'optik', 'dokter'] },
  { label: 'UGD Baru', icon: 'add_circle', class: 'primary', link: 'ugd/daftar', authorized: ['admin', 'admission', 'ugd'] },
  { label: 'List UGD', icon: 'flash_on', class: 'secondary', link: 'ugd', authorized: ['admin', 'admission', 'ranap', 'ugd', 'operasi', 'lab', 'apotik', 'optik', 'dokter'] },
  { label: 'Ranap Baru', icon: 'add_circle', class: 'primary', link: 'ranap/daftar', authorized: ['admin', 'admission', 'ranap','kasir'] },
  { label: 'List Ranap', icon: 'local_hotel', class: 'secondary', link: 'ranap', authorized: ['admin', 'admission', 'ranap', 'dokter','kasir'] },
  { label: 'Operasi Baru', icon: 'add_circle', class: 'primary', link: 'operasi/daftar', authorized: ['admin', 'admission', 'operasi'] },
  { label: 'List Operasi', icon: 'accessible', class: 'secondary', link: 'operasi', authorized: ['admin', 'admission', 'operasi', 'dokter'] },
  { label: 'Periksa Lab', icon: 'hourglass_full', class: 'secondary', link: 'lab', authorized: ['admin', 'lab'] },
  { label: 'Apotik', icon: 'lens', class: 'secondary', link: 'apotik', authorized: ['admin', 'apotik'] },
  { label: 'Optik', icon: 'visibility', class: 'secondary', link: 'optik', authorized: ['admin', 'optik'] },
  { label: 'Kasir', icon: 'account_balance_wallet', class: 'info', link: 'kasir', authorized: ['admin'] },
  { label: 'Tagihan Ralan', icon: 'local_hospital', class: 'info', link: 'kasir', authorized: ['kasir'] },
  { label: 'Tagihan Ranap', icon: 'local_hotel', class: 'secondary', link: 'kasir/ranap', authorized: ['kasir'] },
  { label: 'Tagihan UGD', icon: 'flash_on', class: 'primary', link: 'kasir/ugd', authorized: ['kasir'] },
  { label: 'Tagihan Obat & Alkes', icon: 'lens', class: 'info', link: 'kasir/obat', authorized: ['kasir'] },
  { label: 'Tagihan Optik', icon: 'visibility', class: 'secondary', link: 'kasir/optik', authorized: ['kasir'] },
  { label: 'Tagihan Lab', icon: 'hourglass_full', class: 'primary', link: 'kasir/lab', authorized: ['kasir'] },
  { label: 'Tagihan Operasi', icon: 'accessible', class: 'info', link: 'kasir/operasi', authorized: ['kasir'] },
  { label: 'Rekam Medis', icon: 'perm_contact_calendar', class: 'secondary', link: 'pasien', authorized: ['kasir'] },
  { label: 'List Ralan', icon: 'local_hospital', class: 'secondary', link: 'ralan', authorized: ['kasir'] },
  { label: 'List UGD', icon: 'flash_on', class: 'secondary', link: 'ugd', authorized: ['kasir'] },
  { label: 'Antrian', icon: 'queue_play_next', class: 'info', link: 'antrian', authorized: ['admin', 'admission'] },
  { label: 'Siakun', icon: 'euro_symbol', class: 'primary', link: siakunURL, authorized: ['admin'], fullUrl:true }
  ,
  { label: 'HRIS', icon: 'group', class: 'secondary', link: hrisURL, authorized: ['admin'], fullUrl:true }
];
let roleLabel = '';
let found = roles.find((item) => { return item.value == localStorage.getItem('simrs_role') });
if (found) {
  roleLabel = found.label;
}
const store = new Vuex.Store({
  state: {
    whatsapp: {
      header: 'Chat dengan admin untuk pendaftaran rawat jalan via whatsapp',
      footer: 'Jam pendaftaran via whatsapp 06:00 - 19:00 WIB',
      template: `Halo, Saya ingin melakukan pendaftaran rawat jalan pada tanggal: ${getDateID()} untuk / Nama:                      / No RM:                      / Poli:                      / Dokter:                      / Keluhan:                      `,
      attendants: [
        {
          app: 'whatsapp',
          label: 'Admin Rawat Jalan',
          name: 'Pekan Baru Eye Center',
          number: '6285216888614',
          href: '#',
          text: 'testing',
          avatar: {
            src: 'https://pbs.twimg.com/profile_images/1046605600690339840/QOuvN8Je_400x400.jpg',
            alt: 'Admin Rawat Jalan'
          }
        },
      ]
    },
    prefix: {
      general: 'apigenerated_',
      dok: prefixDok,
      ptg: prefixPtg
    },
    baseStorageURL,
    roles: roles,
    menus: menus,
    token: localStorage.getItem('simrs_token'),
    userId: localStorage.getItem('simrs_userId'),
    email: localStorage.getItem('simrs_email'),
    role: localStorage.getItem('simrs_role'),
    name: localStorage.getItem('simrs_name'),
    username: (localStorage.getItem('simrs_name') ? localStorage.getItem('simrs_name') : localStorage.getItem('simrs_email')),
    id_dokter: localStorage.getItem('simrs_id_dokter'),
    id_petugas: localStorage.getItem('simrs_id_petugas'),
    roleLabel: roleLabel,
    HTTP_JSON: axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('simrs_token')}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }),
    HTTP: axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('simrs_token')}`,
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }),
    HTTP_SIAKUN: axios.create({
      baseURL: siakunBaseURL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('simrs_token')}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }),
    HTTP_HRIS: axios.create({
      baseURL: hrisBaseURL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('simrs_token')}`,
        Accept: "*/*",
        "Content-Type": "application/json"
      }
    }),
    HTTP_ENC: axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('simrs_token')}`,
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }),
    simrsSecretPassphrase: 'AyoHIDUpSeH4tdanBahagia'
  },
  mutations: {
    login(state, payload) {
      localStorage.setItem('simrs_token', payload.token);
      localStorage.setItem('simrs_userId', payload.userId);
      localStorage.setItem('simrs_email', payload.email);
      localStorage.setItem('simrs_role', payload.role);
      localStorage.setItem('simrs_name', payload.name);
      if (payload.id_dokter) {
        localStorage.setItem('simrs_id_dokter', payload.id_dokter);
        state.id_dokter = localStorage.getItem('simrs_id_dokter');
      }
      if (payload.id_petugas) {
        localStorage.setItem('simrs_id_petugas', payload.id_petugas);
        state.id_petugas = localStorage.getItem('simrs_id_petugas');
      }
      state.token = localStorage.getItem('simrs_token');
      state.userId = localStorage.getItem('simrs_userId');
      state.email = localStorage.getItem('simrs_email');
      state.role = localStorage.getItem('simrs_role');
      state.name = localStorage.getItem('simrs_name');
      state.HTTP = axios.create({
        baseURL: baseURL,
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      state.HTTP_JSON = axios.create({
        baseURL: baseURL,
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      state.HTTP_SIAKUN = axios.create({
        baseURL: siakunBaseURL,
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      state.HTTP_HRIS = axios.create({
        baseURL: hrisBaseURL,
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: "*/*",
          "Content-Type": "application/json"
        }
      });
      state.HTTP_ENC = axios.create({
        baseURL: baseURL,
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      state.username = (store.state.name ? store.state.name : store.state.email);
      let found = state.roles.find((item) => { return item.value == state.role });
      if (found) {
        state.roleLabel = found.label;
      }
      else {
        state.roleLabel = '';
      }
      ////console.log(state);
    },
    logout(state) {
      localStorage.removeItem('simrs_token');
      localStorage.removeItem('simrs_userId');
      localStorage.removeItem('simrs_email');
      localStorage.removeItem('simrs_role');
      localStorage.removeItem('simrs_name');
      localStorage.removeItem('simrs_id_dokter');
      localStorage.removeItem('simrs_id_petugas');
      state.token = '';
      state.userId = '';
      state.email = '';
      state.role = '';
      state.name = '';
      state.username = '';
      state.roleLabel = '';
      state.id_dokter = '';
      state.id_petugas = '';
      state.HTTP = axios.create({
        baseURL: baseURL,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      state.HTTP_SIAKUN = axios.create({
        baseURL: siakunBaseURL,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      state.HTTP_HRIS = axios.create({
        baseURL: hrisBaseURL,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        }
      });
      state.HTTP_ENC = axios.create({
        baseURL: baseURL,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      ////console.log(state);
    }
  },
  actions: {
    login({ commit }, payload) {
      commit('login', payload);
      ////console.log('login')
    },
    logout({ commit }) {
      commit('logout');
      ////console.log('logout');
    }
  }
})

export default store

